import { ChartProvider } from '@/components/Chart/context/ChartContext';
import { AccordionProvider } from '@/features/DataHub/components/ExportDrawer/AccordionContext';
import { ExportDrawerLayout } from '@/features/DataHub/components/ExportDrawer/ExportDrawerLayout';
import FooterButtons from '@/features/DataHub/components/ExportDrawer/FooterButtons';
import { PreviewCard } from '@/features/DataHub/components/Preview/PreviewCard';
import DataHubExport from '@/features/DataHub/modules/Export';
import { ExportType, ItemDetailsSection } from '@/features/DataHub/modules/Export/components/Cards';
import ExportSettings from '@/features/DataHub/modules/Export/components/ExportSettings';

export const ExportConfigView = ({ openKey }: { openKey: string }) => {
  return (
    <ChartProvider>
      <ExportDrawerLayout footer={<FooterButtons />}>
        <AccordionProvider key={openKey}>
          <ItemDetailsSection />
          <ExportType />
          <ExportSettings />
          <PreviewCard />
          <DataHubExport />
        </AccordionProvider>
      </ExportDrawerLayout>
    </ChartProvider>
  );
};
